
import { Component, Vue, Watch } from 'vue-property-decorator';

import Datepicker from 'vuejs-datepicker';

import CPOptionDropdown from '@/components/open-account/input/CPOptionDropdown.vue';
import CPSkeletonLoader from '@/components/globals/CPSkeletonLoader.vue';

// userTransactions.details.rptFeeTransHistory


interface UserTransactions {
  details: UserTransactionDetails;
  id: number;
  name: string;
  username: string;
  accountNumber: string;
  open: boolean;
}

interface TransactionGroup {
    [key: string]: TransHistoryItem[] | CashBalanceItem[];
}

interface CashBalanceItem {
  AccountType: string;
  Amount: number;
  Batch: number | null;
  BostonId: number | null;
  CurrDateInCashPos: number| null;
  Currency: string | null;
  CurrencySymbol: string | null;
  DataDate: string | null;
  Description: string;
  PlatformActTypeID: number | null;
  PlatformID: number | null;
  Rate: number | null;
  RemainigBalance: number | null;
  UserInfoId: string | null;
  VendorId: string | null;
}

interface UserTransactionDetails {
  grdTransactions: TransactionGroup;
  rptCashBalance: TransactionGroup;
  rptFeeTransHistory: TransactionGroup;
  rptSecTransHistory: TransactionGroup;
  transTypes: TransactionGroup;
}

interface TransHistoryItem {
  Currency: string;
  CurrencySymbol: string;
  Description: string;
  GrossAmount: null | number;
  NetAmount: number;
  RowNumber: null | number;
  RunningBalance: number;
  TransactionCategory: string;
  TransactionDate: string;
  TransactionID: number | null;
  TransactionType: string;
  UniqueID: number;
}


@Component({
  components: {
    Datepicker,
    CPOptionDropdown,
    CPSkeletonLoader,
  },
})
export default class CPTransactionDetails extends Vue {

  public loading: boolean = false;
  public today: Date = new Date();

  public getAllTransactions: boolean = false;
  public startDate: Date  = this.today;
  public endDate: Date  = this.today;

  public filterSelected: any = null;

  public get userTransactions(): UserTransactions {
    return this.$store.state.userTransactions;
  }


  public get filterOptions(): any {
    if (this.userTransactions.details.transTypes && this.userTransactions.details.transTypes.ddlCashTransactionTypes) {
      // @ts-ignore - tell Typescript to ignore this line as it throws a bug in error - this bug has been resolved in TS v.4.2 > so delete this line once upgraded
      return this.userTransactions.details.transTypes.ddlCashTransactionTypes.map((value) => ({
        value,
        text: value,
      }));
    } else {
      return null;
    }
  }

  public async getTransactionDetails() {
    this.loading = true;

    if (this.startDate > this.today || this.endDate > this.today) {
      this.$store.commit('addError', 'Please make sure to enter a date in past, not a future date.');
    } else {
      await this.$store.dispatch('getUserTransactions', {
        id: this.$store.state.userTransactions.id,
        startDate: this.startDate,
        endDate: this.endDate,
        getAllTransactions: this.getAllTransactions});
    }
    this.loading = false;
  }

  // Print info

  // Get HTML to print from element
  public async printStatement() {
    const prtHtml = document.querySelector('.cp-transaction-details')!.innerHTML;

    // Get all stylesheets HTML
    let stylesHtml = `<style>
      @media print {
        h3 {
          font-size: 14px !important;
          font-weight: bold !important;
          margin-bottom: 0px !important;
        }
        table {
          width: 100% !important;
          table-layout: fixed !important;
        }
        .transaction-table {
          width: 100% !important;
          min-width: 700px !important;
        }

        thead {
          border-bottom: 2px solid #a3a3a3 !important;
        }
        th {
          color: #a3a3a3 !important;
          font-size: 12px !important;
          font-weight: bold !important;
          padding: 5px !important;
        }
        tr {
          border-bottom: 1px solid #a3a3a3 !important;
        }
        td {
          padding: 5px !important;
          color: #212529 !important;
          font-size: 12px !important;
          font-weight: bold !important;
        }
        .email {
          font-size: $font-body !important;
          color: #a3a3a3 !important;
        }
        .transactions-wrapper {
          padding: 30px !important;
        }
        .cp-button, .date-selection, hr, .cp-form-input {
          display: none !important;
        }
      }
    </style>`;
    for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      stylesHtml += node.outerHTML;
    }

    // Open the print window
    const WinPrint = window.open('', '', 'left=0,top=0,width=595,height=842,toolbar=0,scrollbars=0,status=0')!;

    WinPrint.document.write(`<!DOCTYPE html>
    <html>
      <head>
        ${stylesHtml}
      </head>
      <body>
        ${prtHtml}
      </body>
    </html>`);

    WinPrint.document.title = 'Transactions';

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    setTimeout(() => {
      WinPrint.close();
    }, 1000);

  }
}
